import { GetOpportunityTermResultDto } from '@api-proxies';
import { ModelBase } from './ModelBase';

export class OpportunityTermValue extends ModelBase implements GetOpportunityTermResultDto {
    static fromInterface(dto: GetOpportunityTermResultDto): OpportunityTermValue {
        const opportunityTermValue = new OpportunityTermValue();
        opportunityTermValue.mapFromInterface(dto);
        return opportunityTermValue;
    }

    avgTotalTerm: number | undefined;
    totalTerm: number | undefined;

    constructor() {
        super();
        this.avgTotalTerm = undefined;
        this.totalTerm = undefined;
    }
}
